// Pure toggle for a sector multi-select: returns a new array with `slug` added
// when absent or removed when present. Never mutates the input.
//
// Used by SectorSelector.jsx (Settings → Algemeen) to update the in-flight
// selection before writing CompagnyMeta.SelectedSectors.
//
// @param {string[]} [current] - currently selected sector slugs
// @param {string} slug - the sector slug to toggle
// @returns {string[]} the new selection
const toggleSectorSelection = (current, slug) => {
    const list = Array.isArray(current) ? current : []
    return list.includes(slug)
        ? list.filter((s) => s !== slug)
        : [...list, slug]
}

export default toggleSectorSelection
